import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { SiteHeader } from "../../components/header/header";
import { ItemCard } from "../../components/containers/item-card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

import { InviewAnim } from "../../components/utils/animations";
import { CartAddForm } from "../../components/utils/cart-add-form";
import { DarkBg } from "../../components/containers/dark-bg";
import { LoadingIndicator } from "../../components/utils/loader";
import { useProduct } from "../../services/products/product.context";
import InfiniteCarousel from "../../components/utils/infinite-carousel";
import { isNew } from "../../_helpers/is-new";
import { FAQComponent } from "../../components/containers/faqs";
import { AboutComponent } from "../../components/containers/about";
import { FooterComponent } from "../../components/footer/footer";
import { brands, categories } from "../../_helpers/mock-data";
import { ProductCard } from "../../components/cards/product.card";
import { CostFilter } from "../../components/utils/cost-filter";





export const Homepage = () => {

    const navigateTo = useNavigate();

    const {
        someProducts,
        loading,
        cart,
        wishList,
        addTowishList,
        pageNum,
        handlePrevPage,
        handleNextPage,
        allProducts
    } = useProduct();

    const [openCart, setOpenCart] = useState(false);
    const [picked, setPicked] = useState();
    const [inventory, setInventory] = useState([]);
    const [showCostFilter, setShowCostFilter] = useState(false);
    const [costRange, setCostRange] = useState();

    const brandsRef = useRef();
    const productsRef = useRef();
    const catRef = useRef();




    useEffect(() => {
        (async () => {
            setInventory(someProducts);
        })();
    }, [someProducts])

    const getCartElement = (elem) => {
        const cartElem = cart?.find((val) => val._id === elem._id);
        if (cartElem) {
            return cartElem;
        }
        return elem;
    }

    const filterByCost = (min, max) => {
        const itemList = allProducts?.filter((product) => (
            product?.pricing?.original_cost >= min &&  product?.pricing?.original_cost < max
        ));
        setInventory(itemList);
        setCostRange(`${min} - ${max - 100}`);
    }

    const cancelCostFilter = () => {
        setInventory(someProducts);
        setCostRange();
    }



    const scrollToProducts = () => productsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: "start"
    })

    const scrollTobrands = () => brandsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: "start"
    })

    const scrolltoNewArrivals = () => {

        catRef.current.scrollIntoView({
            behavior: 'smooth',
            block: "start"
        });

        const filtData = inventory?.filter((datum) => isNew(datum));
         filtData?.length > 0 ? setInventory(filtData): setInventory(inventory);
        catRef?.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        })
        return;
    }

   

    return (
        <div className="app-body">
            <SiteHeader pageTitle={'KEVO TELECOM'} />
            {loading && <LoadingIndicator />}
            {openCart && (
                <DarkBg>
                    <CartAddForm
                        itemData={picked}
                        closeCart={() => setOpenCart(false)}
                        opened={openCart}
                        cart={cart}
                    />
                </DarkBg>
            )}
            <div className="welcome-section">
                <div className="thin-text f-hero">PREMIUM MOBILE ECOSYSTEM</div>
                <InviewAnim inView={'rotate-in-after'} notInView={'rotate-in-before'}>
                    <div className="slogans">
                        <div className="slogan-1">WE ARE REAL</div>
                        <div className="slogan-2">NO FICTION</div>
                    </div>
                </InviewAnim>
                <InviewAnim inView={'slide-up-y-after'} notInView={'slide-up-y-before'}>
                    <div className="brief-text">
                        Shop with us for the world's most advanced smart phones and precision-engineered accessories.
                    </div>
                </InviewAnim>
            </div>


            <div className="feature-slide">
                <InfiniteCarousel
                    toBrands={scrollTobrands}
                    toProducts={scrollToProducts}
                    toNew={scrolltoNewArrivals}
                />
            </div>

            <div className="explore-brands">
                <div className="thin-text br-cap">ECOSYSTEM PARTNERS</div>
                <div className="slogan-1 br-cap">EXPOLORE BY BRAND</div>
                <div className="brand-list" ref={brandsRef}>
                    {brands.map((brand, id) => (
                        <InviewAnim
                            key={id}
                            inView={'slide-in-y-after'}
                            notInView={'slide-in-y-before'}
                        >
                            <button
                                className="brand-button"
                                onClick={() => window.location.href = `/categories?brand=${brand.name}`}
                            >
                                <span className="brand-name">{brand.name}</span>
                                <img src={brand.logo} alt="" className="brand-pic" />
                            </button>
                        </InviewAnim>
                    ))}
                </div>
            </div>
            <div className="explore-brands">
                <div className="thin-text br-cap">PRODUCT LINES</div>
                <div className="slogan-1 br-cap">SHOP BY CATEGORY</div>
                <div className="brand-list" ref={productsRef}>
                    {categories.map((category, id) => (
                        <InviewAnim
                            key={id}
                            inView={'slide-in-x-after'}
                            notInView={'slide-in-x-before'}
                        >
                            <button
                                className="brand-button"
                                onClick={() => window.location.href = `/categories?category=${category.name}`}
                                key={id}
                            >
                                <span className="brand-name">{category.name}</span>
                                <img src={category.icon} alt="" className="brand-pic" />
                            </button>
                        </InviewAnim>
                    ))}
                </div>
            </div>

            <div className="thin-text br-cap">FEATURED SELECTION</div>
            <div className="slogan-1 br-cap">ALL PRODUCTS</div>
            <div className="filter-button-box">
                <button 
                    className="filter-button lng"
                    onClick={() => setShowCostFilter((v) => !v) }
                >
                    <img src="/svgs/filter-sort.svg" alt="" className="sm-svg" />
                    <span className="sm-text">
                        {costRange ? `FCFA ${costRange}`: `Filter by cost`}
                    </span>
                </button>
                {/* {costRange && <span className="range-label">FCFA {costRange}</span> } */}
            </div>
            <CostFilter 
                shown={showCostFilter}
                handleFilter={(v,w) => filterByCost(v,w)}
                cancelFilter={cancelCostFilter} 
            />
            {inventory?.length ? (
                <div className="catalog" ref={catRef}>
                    {inventory?.map((item, id) => (
                        <InviewAnim
                            key={id}
                            inView={'slide-up-after'}
                            notInView={'slide-up-before'}
                        >
                            <ProductCard
                                onCartAdd={() => {
                                    const elem = getCartElement(item);
                                    setPicked(elem);
                                    setOpenCart(true);
                                }}
                                onLike={() => addTowishList(item)}
                                item={item}
                                cart={cart}
                                wishList={wishList}
                                onClick={() => navigateTo("/details", { state: item })}
                            />
                        </InviewAnim>
                    ))}
                </div>
            ) :
                <div className="no-product sp-3-st">
                    <div className="slogan-2">No Products listed</div>
                </div>
            }

            <div className="pagin-buttons">
                <button
                    className={classNames("pagin-button", { dis: pageNum === 1 })}
                    onClick={() => handlePrevPage()}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <input
                    type="text"
                    value={pageNum}
                    id=""
                    className={classNames("page-num", { dis: pageNum === 1 && inventory?.length < 20 })}
                />
                <button
                    className={classNames("pagin-button", { dis: inventory?.length < 20 })}
                    onClick={() => handleNextPage()}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>

            <div className="slogan-1 br-cap">FAQ</div>
            <FAQComponent />
            <AboutComponent />
            <FooterComponent />
        </div>
    )
}